import React from "react";
import { Link, useParams } from "react-router-dom";

import PlacementCouncilDashboard from "./Dashboard";
import PlacementEmployers from "./Employers";
import PlacementJobs from "./Jobs";
import PlacementApplications from "./Applications";
import PlacementVerifications from "./Placements";

/**
 * Council > Placement.
 *
 * One entry in the admin sidebar opens this hub; the five placement screens
 * (Dashboard, Employers, Jobs, Applications, Verifications) live here as sub-
 * tabs instead of five separate sidebar links. Nothing about the screens
 * themselves changes - they render below the tab bar, in the panel's existing
 * design. The active tab follows the URL (/admin/placement/<tab>), so old deep
 * links keep working and the browser back/forward buttons move between tabs.
 */
const TABS = [
  { key: "dashboard", label: "Dashboard", Comp: PlacementCouncilDashboard },
  { key: "employers", label: "Employers", Comp: PlacementEmployers },
  { key: "jobs", label: "Jobs", Comp: PlacementJobs },
  { key: "applications", label: "Applications", Comp: PlacementApplications },
  { key: "placements", label: "Verifications", Comp: PlacementVerifications },
];

export default function PlacementHub() {
  const { tab } = useParams();
  const active = TABS.find((t) => t.key === tab) || TABS[0];
  const Active = active.Comp;

  return (
    <div style={{ padding: "4px 2px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 8,
          marginBottom: 14,
        }}
      >
        <h4 style={{ margin: 0, color: "#2c3e50", fontWeight: 700 }}>Placement</h4>
      </div>

      {/* Sub-tab bar */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 6,
          borderBottom: "2px solid #e9ecef",
          marginBottom: 18,
        }}
      >
        {TABS.map((t) => {
          const on = t.key === active.key;
          return (
            <Link
              key={t.key}
              to={"/admin/placement/" + t.key}
              style={{
                padding: "9px 16px",
                borderRadius: "8px 8px 0 0",
                fontSize: 14,
                fontWeight: on ? 700 : 500,
                textDecoration: "none",
                color: on ? "#fff" : "#2c3e50",
                background: on ? "#14274e" : "transparent",
                borderBottom: on ? "2px solid #14274e" : "2px solid transparent",
                marginBottom: -2,
              }}
            >
              {t.label}
            </Link>
          );
        })}
      </div>

      {/* Active section - the existing screen, unchanged */}
      <Active />
    </div>
  );
}
